"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayrollEmployeeCheckDtoStatusEnum = void 0;
exports.instanceOfPayrollEmployeeCheckDto = instanceOfPayrollEmployeeCheckDto;
exports.PayrollEmployeeCheckDtoFromJSON = PayrollEmployeeCheckDtoFromJSON;
exports.PayrollEmployeeCheckDtoFromJSONTyped = PayrollEmployeeCheckDtoFromJSONTyped;
exports.PayrollEmployeeCheckDtoToJSON = PayrollEmployeeCheckDtoToJSON;
exports.PayrollEmployeeCheckDtoToJSONTyped = PayrollEmployeeCheckDtoToJSONTyped;
const PayrollPayPeriodDto_1 = require("./PayrollPayPeriodDto");
const PayrollCheckItemDto_1 = require("./PayrollCheckItemDto");
/**
 * @export
 */
exports.PayrollEmployeeCheckDtoStatusEnum = {
    Pending: 'PENDING',
    Preprocessed: 'PREPROCESSED',
    Processed: 'PROCESSED',
    Voided: 'VOIDED',
    Failed: 'FAILED'
};
/**
 * Check if a given object implements the PayrollEmployeeCheckDto interface.
 */
function instanceOfPayrollEmployeeCheckDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('zealEmployeeCheckId' in value) || value['zealEmployeeCheckId'] === undefined)
        return false;
    if (!('employeeName' in value) || value['employeeName'] === undefined)
        return false;
    if (!('grossPay' in value) || value['grossPay'] === undefined)
        return false;
    if (!('netPay' in value) || value['netPay'] === undefined)
        return false;
    if (!('overtimePay' in value) || value['overtimePay'] === undefined)
        return false;
    if (!('checkDate' in value) || value['checkDate'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('profileId' in value) || value['profileId'] === undefined)
        return false;
    if (!('zealEmployeeId' in value) || value['zealEmployeeId'] === undefined)
        return false;
    if (!('isApproved' in value) || value['isApproved'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    if (!('grossEarnings' in value) || value['grossEarnings'] === undefined)
        return false;
    if (!('employeeTaxes' in value) || value['employeeTaxes'] === undefined)
        return false;
    if (!('employeeDeductions' in value) || value['employeeDeductions'] === undefined)
        return false;
    if (!('employeeGarnishments' in value) || value['employeeGarnishments'] === undefined)
        return false;
    if (!('employerTaxes' in value) || value['employerTaxes'] === undefined)
        return false;
    if (!('employerDeductions' in value) || value['employerDeductions'] === undefined)
        return false;
    if (!('payPeriods' in value) || value['payPeriods'] === undefined)
        return false;
    if (!('checkItems' in value) || value['checkItems'] === undefined)
        return false;
    if (!('isSalaried' in value) || value['isSalaried'] === undefined)
        return false;
    return true;
}
function PayrollEmployeeCheckDtoFromJSON(json) {
    return PayrollEmployeeCheckDtoFromJSONTyped(json, false);
}
function PayrollEmployeeCheckDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'zealEmployeeCheckId': json['zealEmployeeCheckId'],
        'employeeName': json['employeeName'],
        'grossPay': json['grossPay'],
        'netPay': json['netPay'],
        'overtimePay': json['overtimePay'],
        'checkDate': (json['checkDate'] == null ? null : new Date(json['checkDate'])),
        'status': json['status'],
        'profileId': json['profileId'],
        'zealEmployeeId': json['zealEmployeeId'],
        'isApproved': json['isApproved'],
        'processedAt': json['processedAt'] == null ? undefined : (new Date(json['processedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'payPeriodStart': json['payPeriodStart'] == null ? undefined : (new Date(json['payPeriodStart'])),
        'payPeriodEnd': json['payPeriodEnd'] == null ? undefined : (new Date(json['payPeriodEnd'])),
        'grossEarnings': json['grossEarnings'],
        'employeeTaxes': json['employeeTaxes'],
        'employeeDeductions': json['employeeDeductions'],
        'employeeGarnishments': json['employeeGarnishments'],
        'employerTaxes': json['employerTaxes'],
        'employerDeductions': json['employerDeductions'],
        'payPeriods': (json['payPeriods'].map(PayrollPayPeriodDto_1.PayrollPayPeriodDtoFromJSON)),
        'checkItems': (json['checkItems'].map(PayrollCheckItemDto_1.PayrollCheckItemDtoFromJSON)),
        'isSalaried': json['isSalaried'],
    };
}
function PayrollEmployeeCheckDtoToJSON(json) {
    return PayrollEmployeeCheckDtoToJSONTyped(json, false);
}
function PayrollEmployeeCheckDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'zealEmployeeCheckId': value['zealEmployeeCheckId'],
        'employeeName': value['employeeName'],
        'grossPay': value['grossPay'],
        'netPay': value['netPay'],
        'overtimePay': value['overtimePay'],
        'checkDate': (value['checkDate'] == null ? null : value['checkDate'].toISOString()),
        'status': value['status'],
        'profileId': value['profileId'],
        'zealEmployeeId': value['zealEmployeeId'],
        'isApproved': value['isApproved'],
        'processedAt': value['processedAt'] == null ? undefined : (value['processedAt'].toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'payPeriodStart': value['payPeriodStart'] == null ? undefined : (value['payPeriodStart'].toISOString()),
        'payPeriodEnd': value['payPeriodEnd'] == null ? undefined : (value['payPeriodEnd'].toISOString()),
        'grossEarnings': value['grossEarnings'],
        'employeeTaxes': value['employeeTaxes'],
        'employeeDeductions': value['employeeDeductions'],
        'employeeGarnishments': value['employeeGarnishments'],
        'employerTaxes': value['employerTaxes'],
        'employerDeductions': value['employerDeductions'],
        'payPeriods': (value['payPeriods'].map(PayrollPayPeriodDto_1.PayrollPayPeriodDtoToJSON)),
        'checkItems': (value['checkItems'].map(PayrollCheckItemDto_1.PayrollCheckItemDtoToJSON)),
        'isSalaried': value['isSalaried'],
    };
}
//# sourceMappingURL=PayrollEmployeeCheckDto.js.map